import React from "react";
import "./wave.css";

interface WaveProps {
  className?: string;
  variant?: number;
}

/**
 * Wave component
 */
export const Wave: React.FC<WaveProps> = ({ className, variant = 1 }) => (
  // Make wave great again
  <svg
    className={`Wave ${className || ""}`}
    viewBox="0 0 1440 320"
    preserveAspectRatio="xMinYMin meet"
  >
    {variant === 1 ? (
      <path d="M0,128L80,122.7C160,117,320,107,480,128C640,149,800,203,960,202.7C1120,203,1280,149,1360,122.7L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
    ) : variant === 2 ? (
      <path d="M0,160L80,170.7C160,181,320,203,480,202.7C640,203,800,181,960,192C1120,203,1280,245,1360,266.7L1440,288L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
    ) : (
      <path d="M0,96L120,85.3C240,75,480,53,720,69.3C960,85,1200,139,1320,165.3L1440,192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path>
    )}
  </svg>
);
